var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"width":"80px","cursor":"pointer"},attrs:{"src":_vm.i18n_locale_img,"alt":_vm.$i18n.locale},on:{"click":_vm.toggleLocale}})
}
var staticRenderFns = []

export { render, staticRenderFns }